import "./Background.scss";
import ImgBackground from "../imgs/Background.png";

function Background() {
  return (
    <>
      <img src={ImgBackground} alt="bg" id="background" />
    </>
  );
}

export default Background;
